<template>
    <!-- 报警方式 -->
    <el-form-item>
        <!-- <el-tag effect="dark" class="icon-margin" size="medium" v-if="model[index][6] === '1'">{{ $t('integration.mail')
        }}</el-tag>
        <el-tag effect="dark" class="icon-margin" size="medium" v-if="model[index][5] === '1'">{{
            $t('integration.short_message') }}</el-tag>
        <el-tag effect="dark" class="icon-margin" size="medium" v-if="model[index][4] === '1'">{{ $t('integration.voice')
        }}</el-tag> -->

        <div class="uk-text-center lh-30" style="width: 300px;">
            <div class="uk-flex border r-5 mb-5" v-if="way[0] === '1'">
                <div class="bg-theme color-white title-width">{{ $t('integration.mail') }}</div>
                <div class="pl-5 uk-flex-1">{{ model.email }}</div>
            </div>

            <div class="uk-flex border r-5 mb-5" v-if="way[1] === '1'">
                <div class="bg-theme color-white title-width">{{ $t('integration.short_message') }}</div>
                <div class="pl-5 uk-flex-1">{{ model.mobile }}</div>
            </div>

            <div class="uk-flex border r-5" v-if="way[2] === '1'">
                <div class="bg-theme color-white title-width">{{ $t('integration.voice') }}</div>
                <div class="pl-5 uk-flex-1">{{ model.mobile }}</div>
            </div>
        </div>
    </el-form-item>
</template>

<script>
export default {
    props: ['model', 'index'],
    computed: {
        // 前面补0
        way() {
            let way = this.model[this.index];
            while (way.length !== 3) {
                way = '0' + way;
            }
            return way;
        }
    }
};
</script>

<style scoped lang="scss">
.title-width {
    width: 100px;
}
</style>
